import React from 'react';
import Account from './dans';

const PageList = () => <Account />;

export default PageList;
